<template>
  <page-header-wrapper>
    <a-card title="默认会员头像" :bordered="false" :loading="loading">
      <a-alert type="info" show-icon message="未设置个人头像的会员使用此图片，国内版和国际版共用。已上传个人头像的会员不受影响；更换默认图后，下次加载个人资料时生效。" style="margin-bottom:24px" />
      <file-upload :value="form.avatar" type="image" :count="1" :max-size-mb="2" @change="v=>$set(form,'avatar',v)" />
      <p class="hint">建议使用 200×200px 正方形图片，最大 2MB；客户端裁剪为圆形。留空则使用系统默认头像。</p>
      <a-button v-hasPermi="['dkmall:default-avatar:edit']" type="primary" :loading="saving" @click="save">保存默认头像</a-button>
    </a-card>
  </page-header-wrapper>
</template>
<script>
import request from '@/utils/request'
import FileUpload from '@/components/FileUpload'
export default {
  name:'DkDefaultAvatar',components:{FileUpload},
  data(){return {loading:false,saving:false,form:{avatar:''}}},
  created(){this.load()},
  methods:{
    load(){this.loading=true;return request({url:'/dkmall/default-avatar'}).then(r=>{this.form={avatar:(r.data&&r.data.avatar)||''}}).finally(()=>{this.loading=false})},
    save(){this.saving=true;return request({url:'/dkmall/default-avatar',method:'put',data:this.form}).then(()=>this.$message.success('默认头像已保存')).finally(()=>{this.saving=false})}
  }
}
</script>
<style scoped>.hint{color:#888;margin:16px 0 24px}</style>
